import { CSSObject } from '@chakra-ui/react';

export const GridLayout: CSSObject = {
  width: ['full', null, '760px'],
  minH: '100dvh',
  borderRadius: [null, null, 'lg'],
  display: 'flex',
  height: 'auto',
  alignItems: [null, null, 'center'],
  mx: 'auto',
  my: ['unset', null, '4'],
};
